import React from "react";
import { Icon } from "@shopify/polaris";
import {
  LinkMinor,
  TextAlignmentLeftMajor,
  TextBlockMajor,
  HashtagMajor,
  PhoneMajor,
  EmailMajor,
  ClockMajor,
} from "@shopify/polaris-icons";

const contentTypeOptions = (t) => [
  {
    label: t("settings.customFields.contentTypes.text"),
    value: "text",
    prefix: <Icon source={TextAlignmentLeftMajor} color="base" />,
    textFieldOptions: {
      type: "text",
    },
  },
  {
    label: t("settings.customFields.contentTypes.textArea"),
    value: "text_area",
    prefix: <Icon source={TextBlockMajor} color="base" />,
    textFieldOptions: {
      type: "text",
      multiline: 3,
    },
  },
  {
    label: t("settings.customFields.contentTypes.email"),
    value: "email",
    prefix: <Icon source={EmailMajor} color="base" />,
    textFieldOptions: {
      type: "email",
      inputMode: "email",
    },
  },
  {
    label: t("settings.customFields.contentTypes.number"),
    value: "number",
    prefix: <Icon source={HashtagMajor} color="base" />,
    textFieldOptions: {
      type: "number",
      inputMode: "numeric",
    },
  },
  {
    label: t("settings.customFields.contentTypes.phoneNumber"),
    value: "tel",
    prefix: <Icon source={PhoneMajor} color="base" />,
    textFieldOptions: {
      type: "tel",
      inputMode: "tel",
    },
  },
  {
    label: t("settings.customFields.contentTypes.time"),
    value: "time",
    prefix: <Icon source={ClockMajor} color="base" />,
    textFieldOptions: {
      type: "time",
    },
  },
  {
    label: t("settings.customFields.contentTypes.url"),
    value: "url",
    prefix: <Icon source={LinkMinor} color="base" />,
    textFieldOptions: {
      type: "url",
      inputMode: "url",
    },
  },
];
export default contentTypeOptions;
